import useCurrentRetailerAccount from '@src/lib/useCurrentRetailerAccount'

import ManageBrandCustomFields from '../brands/ManageBrandCustomFields'
import { ManageBrandDialogContextProvider } from '../brands/manageBrandsDialogContext'

import retailerSettingsPaths from './retailerSettingsPaths'

const RetailerSettingsBrandSettingsQuestions: React.FC = () => {
  const { ensureCurrentRetailerAccount } = useCurrentRetailerAccount()
  const params = retailerSettingsPaths.brandSettingsQuestions.useParams()
  const currentRetailer = ensureCurrentRetailerAccount?.retailers?.find(
    (x) => String(x.brand?.slug) === String(params.brandSlug),
  )
  const currentRetailerId = currentRetailer?.id
  const currentBrandId = currentRetailer?.brand?.id

  return (
    <>
      <ManageBrandDialogContextProvider
        value={{
          validationMode: 'custom_fields',
          isValid: true,
          setIsValid: () => {},
          shouldHighlightMissing: true,
        }}
      >
        <ManageBrandCustomFields
          retailerAccountId={ensureCurrentRetailerAccount.id}
          retailerId={currentRetailerId || ''}
          brandId={currentBrandId}
          isInBusinessSettings
        />
      </ManageBrandDialogContextProvider>
    </>
  )
}

export default RetailerSettingsBrandSettingsQuestions
